








import { Component, Vue } from "vue-property-decorator";
import FormularioCarnaval from "@/components/Formularios/FormularioCarnaval.vue";

@Component({
  components: {
    FormularioCarnaval
  },
  meta: {
    // sets document title
    title:
      "Solicitud Oficial de Inscripción en el Carnaval de Invierno 2025 - Ilustre Municipalidad de Punta Arenas",
    // optional; sets final title as "Index Page - My Website", useful for multiple level meta
    //titleTemplate: title => `${title} - My Website`,

    // meta tags
    meta: {
      description: {
        name: "description",
        content: "Ilustre Municipalidad de Punta Arenas"
      },
      keywords: { name: "keywords", content: "Punta Arenas" },
      equiv: {
        "http-equiv": "Content-Type",
        content: "text/html; charset=UTF-8"
      }
    }
  }
})
export default class CarnavalView extends Vue {
  private mounted() {
    document.title =
      "Solicitud Oficial de Inscripción en el Carnaval de Invierno 2025 - Ilustre Municipalidad de Punta Arenas";
  }
}
